@if (roleService.isAuthorized('replacevehiclequote_viewconfirmationpage') | async) {
  <div class="main row">
    <ds-confirmation [confirmationData]="confirmationData">
      <ds-confirmation-link-area>
        <a class="font-weight-semibold done-button" href="javascript:void(0);" (click)="done()"
          >Done</a
        >
      </ds-confirmation-link-area>
    </ds-confirmation>
  </div>
}
